import { render, staticRenderFns } from "./GrupoSegurancaList.vue?vue&type=template&id=79e2342c&"
import script from "./GrupoSegurancaList.vue?vue&type=script&lang=js&"
export * from "./GrupoSegurancaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports